import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", {
    class: "role-badge",
    style: _normalizeStyle({ color: $setup.role_data.color })
  }, _toDisplayString($setup.role_data.title), 5 /* TEXT, STYLE */))
}